export function tryIncreaseDepth(dragItem) {
  const { maxDepth, childrenProp, collapsed } = this.props;
  const pathFrom = this.getPathById(dragItem.id);
  const itemIndex = pathFrom[pathFrom.length - 1];
  const newDepth = pathFrom.length + this.getItemDepth(dragItem);

  // has previous sibling and isn't at max depth
  if (itemIndex > 0 && newDepth <= maxDepth) {
    const prevSibling = this.getItemByPath(pathFrom.slice(0, -1).concat(itemIndex - 1));
    // previous sibling is not collapsed
    if (!prevSibling[childrenProp].length || !this.isCollapsed(prevSibling)) {
      const pathTo = pathFrom
        .slice(0, -1)
        .concat(itemIndex - 1)
        .concat(prevSibling[childrenProp].length);

      // if collapsed by default
      // and was no children here
      // open this node
      let collapseProps = {};
      if (collapsed && !prevSibling[childrenProp].length) {
        collapseProps = this.onToggleCollapse(prevSibling, true);
      }

      this.moveItem({ dragItem, pathFrom, pathTo }, collapseProps);
    }
  }
}
